import { procurementAPI } from "../../axios";

export const actions = {
    GetAllCampusPr(context, data){
        return procurementAPI.get(`CampusPr/GetCampusPrs/${data.campusId}/${data.cycle}`);
    },
    GetDraftCampusPr(context, data){
        return procurementAPI.get(`CampusPr/Draft/${data.campusId}/${data.cycle}`);
    },
    UpdateCampusPr(context, data){
        return procurementAPI.put(`CampusPr/Update/${data.id}`, data);
    },
    DeleteCampusPr(context, data){
        return procurementAPI.delete(`CampusPr/Remove/${data}`);
    },
    CreateCampusPr(context, data){
        return procurementAPI.post(`CampusPr/Create/${data.campusId}/${data.cycle}`, data);
    },
}